import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'searchResultSubjectName'
})
@Injectable({
  providedIn: 'root'
})
export class SearchResultSubjectNamePipe implements PipeTransform {

  transform(src: any): any {
    if (!src || !src.data) return '';
    const { data } = src;

    if (data.opsubType === 'BSM') {

      if (data.name) return data.name;
      const name1 = [data.firstName, data.surname].filter(Boolean).join(' ');
      const name2 = [data.firstName2, data.surname2].filter(Boolean).join(' ');
      return [name1, name2].filter(Boolean).join(' a ');
    }

    if (data.name) return data.name;

    return [data.firstName, data.surname].filter(Boolean).join(' ');
  }
}
